import { Component, OnInit } from '@angular/core';
import { ModalController, NavController, Platform, ToastController } from '@ionic/angular';
import { Store } from '@ngrx/store';
import { AppState } from '../../../angular-wallet-base/store/appState';
import {
  ChangeSecondatyTitleAction,
  ChangeTitleAction,
  UseI18nOnTitleAction,
} from '../../../angular-wallet-base/actions/appSettings.actions';
import { getToastPosition, getTokenInfo, openKYC } from '../../../angular-wallet-base/utils';
import { getKeychain } from '../../../angular-wallet-base/store/wallet';
import { getBaseCurrency } from '../../../angular-wallet-base/store/userPreferences';
import { MembersPortalService } from '../../../angular-wallet-base/services/members-portal.service';
import { ActivatedRoute } from '@angular/router';
import { createKeyringId } from '../../../angular-wallet-base/keyringUtils';
import { TranslateService } from '@ngx-translate/core';
import { BuyLearnMoreComponent } from 'src/app/components/buy-learn-more/buy-learn-more.component';
import { WalletService } from 'src/app/angular-wallet-base/services/wallet.service';
import { CaptureEmailModalComponent } from 'src/app/components/capture-email-modal/capture-email-modal.component';
import { UpdateJwtAction } from 'src/app/angular-wallet-base/actions/userPreferences.actions';
import { getServiceStatus } from '../../../angular-wallet-base/store/connection';
import { PreviousRouteService } from '../../../angular-wallet-base/services/previousroute.service';
import { SubscriptionListenerComponent } from '../../../angular-wallet-base/SubscriptionListenerComponent';
import { AppModeService } from '../../../angular-wallet-base/services/app-mode.service';
import { KycModalComponent } from 'src/app/components/kyc-modal/kyc-modal.component';
import { ComplianceService } from 'src/app/angular-wallet-base/services/compliance.service';

const flags = ['isDeliverLodeEnabled', 'isBuyLodeFromDealerEnabled', 'isBuyLodeFromSilverCardEnabled','isBuyLodeByBankTransferEnabled', 'isBuyLodeWithCryptoEnabled'];

@Component({
  selector: 'app-buy-or-redeem',
  templateUrl: './buy-or-redeem.component.html',
  styleUrls: ['./buy-or-redeem.component.scss'],
})
export class BuyOrRedeemComponent extends SubscriptionListenerComponent implements OnInit {
  public fiatValue: string;
  public userCurrency: string = 'USD';
  public isLodeLinked;
  public completedKyc;
  public tokenSymbol;
  public tokenGuid;
  public baseChainSymbol;
  public tokenInfo;
  public exchangeRate;
  public isDesktopMode;
  public isFlagsEnables = null;
  public isLodeToken = false;
  public gasStationStatus;
  public backPage: string;
  public userCompletedKyc;
  public loadingKYC: boolean = false;
  public loading;

  constructor(
    protected store: Store<AppState>,
    private nav: NavController,
    private toast: ToastController,
    private membersPortal: MembersPortalService,
    private complianceService: ComplianceService,
    private activatedRoute: ActivatedRoute,
    private translate: TranslateService,
    private modal: ModalController,
    private walletService: WalletService,
    private routeService: PreviousRouteService,
    private appMode: AppModeService,
    private platform: Platform
  ) {
    super(store);
    this.appMode.isDesktopMode.subscribe(mode => this.isDesktopMode = mode);
  }

  async ngOnInit() {
    this.loading = true

    this.baseChainSymbol = this.activatedRoute.snapshot.queryParams.baseChainSymbol;
    this.tokenGuid = this.activatedRoute.snapshot.queryParams.guid;
    this.tokenSymbol = this.activatedRoute.snapshot.queryParams.symbol;

    this.verifyIsLodeLinked();
    this.userCompletedKyc = await this.complianceService.verifyIfKYCIsCompleted();

    this.loading = false
    if (!this.isLodeLinked && !this.userCompletedKyc) {
      return
    }

    
    const keyrindId = createKeyringId(this.baseChainSymbol, this.tokenGuid);
    let quote;
    try {
      quote = await this.membersPortal.getPriceQuote(10, '', '1', this.tokenSymbol.toLowerCase());
      this.exchangeRate = quote.data.ppt;
    } catch (err) {
      // wont show token rate
    }
    this.store.select(getServiceStatus).subscribe((statuses) => {
      this.gasStationStatus = statuses.gasStation;
    });

    this.store.select(getKeychain).subscribe((keychain) => {
      try {
        this.tokenInfo = getTokenInfo(keychain, keyrindId);
        this.fiatValue = this.tokenInfo.retailFiatValue.toFixed(5);
      } catch (err) {
        this.fiatValue = '0.00000';
      }
    });

    this.store.select(getBaseCurrency).subscribe((currency) => {
      this.userCurrency = currency;
    });
  }

  async openKYCModal() {
    this.loadingKYC = true;
    await openKYC(this.loading, this.complianceService, this.translate,this.toast,this.modal,this.platform);
    this.loadingKYC = false;
  }

  async ngAfterViewInit() {
    const buy_title = await this.translate.get(`pages.buy_${this.tokenSymbol.toLowerCase()}`).toPromise();
    this.store.dispatch(new ChangeTitleAction(buy_title));
    this.store.dispatch(new ChangeSecondatyTitleAction(''));
    this.store.dispatch(new UseI18nOnTitleAction(false));
    this.backPage = this.routeService.previousUrl;
  }

  goToBillingForm() {
    this.nav.navigateForward(['/wallet/buy-tokens/step-two'], {
      queryParams: { symbol: this.tokenSymbol, guid: this.tokenGuid, baseChainSymbol: this.baseChainSymbol },
    });
  }

  goToRedeem() {
    this.nav.navigateForward(['/wallet/buy-tokens/step-three'], {
      queryParams: { symbol: this.tokenSymbol, guid: this.tokenGuid, baseChainSymbol: this.baseChainSymbol },
    });
  }

  goToSilverBullion() {
    this.nav.navigateForward(['/wallet/buy-tokens/silver-bullion'], {
      queryParams: { symbol: this.tokenSymbol, guid: this.tokenGuid, baseChainSymbol: this.baseChainSymbol },
    });
  }

  goToWireTransfer() {
    this.nav.navigateForward(['/wallet/buy-tokens/wire-transfer'], {
      queryParams: { symbol: this.tokenSymbol, guid: this.tokenGuid, baseChainSymbol: this.baseChainSymbol },
    });
  }

  goToCryptoPayment(){
    this.nav.navigateForward(['/wallet/buy-tokens/crypto-payment'], {
      queryParams: { symbol: this.tokenSymbol, guid: this.tokenGuid, baseChainSymbol: this.baseChainSymbol },
      animated: false
    });
  }

  goToLinkLode() {
    this.nav.navigateForward(['/wallet/settings']);
  }

  async openLearnMoreModal(token, isDesktop) {
    const modal = await this.modal.create({
      component: BuyLearnMoreComponent,
      componentProps: {
        token,
        mode: isDesktop ? 'desktop' : 'mobile',
      },
    });

    await modal.present();
  }

  async openModal() {
    const modal = await this.modal.create({
      component: CaptureEmailModalComponent,
      cssClass: 'capture-email-modal',
      id: 'CaptureEmail',
      componentProps: {
        showLinkAccount: false,
        showDoNotAsk: false,
        showSkipForNow: false,
        showCancelBtn: true,
      },
    });

    modal.onDidDismiss().then(async (result) => {
      var resCaptureEmail = result.data;
      if (resCaptureEmail) {
        if (resCaptureEmail === 'cancelBtn') return;
        this.store.dispatch(new UpdateJwtAction({ jwtToken: resCaptureEmail.access_token, lodeid: resCaptureEmail.data.lodeid }));
        this.verifyIsLodeLinked(resCaptureEmail.access_token);
      }
    });

    await modal.present();
  }

  async verifyIsLodeLinked(accessToken = '') {
    try {
      this.isLodeLinked = await this.membersPortal.isJwtValid(accessToken);
      if (this.isLodeLinked) {
        if (this.tokenSymbol.toLowerCase() === 'lode') {
          this.isLodeToken = true;
          this.tokenInfo = null;
          this.isFlagsEnables = await this.membersPortal.getFeatureFlags(flags);
        }
      }
    } catch (err) {
      console.log(err);
    }
  }
  goBack() {
    if (this.appMode.isDesktopMode.value) {
      return this.nav.back();
    } else {
      if (this.backPage) {
        return this.nav.navigateBack(this.backPage);
      } else {
        return this.nav.back();
      }
    }
  }
  
  goToSecuritySettings() {
    this.nav.navigateForward(['wallet', 'settings'], {
      queryParams: {
        tab: 'wallet',
      },
    });
  }
}
